import { ISOCountryCode, parseCountryCode } from '@pmi.web/countries';
import { useEffect } from 'react';
import { useFormContext } from 'react-hook-form';

import { DefaultCountryAddress } from './_default/DefaultCountryAddress';
import { JPCountryAddress } from './jp/JPCountryAddress';
import { USCountryAddress } from './us/USCountryAddress';

export interface IAddressFormProps {
  readonly country: ISOCountryCode;
  readonly env: 'development' | 'production';
  readonly required?: boolean;
}

export function AddressInput(props: IAddressFormProps) {
  const { country, env, required = false } = props;
  const Form = getCountryForm(country);

  const { setValue } = useFormContext();

  useEffect(() => {
    setValue('address.country', country);
  }, [country, setValue]);

  return <Form env={env} isoCountryCode={country} required={required} />;
}

function getCountryForm(country: string) {
  const isoCountry = parseCountryCode(country);

  if (isoCountry === ISOCountryCode.UnitedStatesAmerica) {
    return USCountryAddress;
  } else if (isoCountry === ISOCountryCode.Japan) {
    return JPCountryAddress;
  }

  return DefaultCountryAddress;
}
